import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";

const VISITOR_KEY = "masterSolVisitorId";

const getVisitorId = () => {
  let visitorId = localStorage.getItem(VISITOR_KEY);

  if (!visitorId) {
    visitorId = `visitor_${Date.now()}_${Math.random()
      .toString(36)
      .substring(2, 10)}`;

    localStorage.setItem(VISITOR_KEY, visitorId);
  }

  return visitorId;
};

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    console.log(
      "VISITOR TRACKER:",
      location.pathname,
      location.search
    );

    const visitorId = getVisitorId();

    fetch(`${API_BASE_URL}/api/web-visitors/track`, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
      },

      body: JSON.stringify({
        visitor_id: visitorId,
        page: `${location.pathname}${location.search}`,
      }),
    })
      .then(async (response) => {
        console.log(
          "VISITOR TRACK STATUS:",
          response.status
        );

        if (!response.ok) {
          const data = await response
            .json()
            .catch(() => ({}));

          console.error(
            "VISITOR TRACK FAILED:",
            data
          );
        }
      })
      .catch((error) => {
        console.error(
          "VISITOR TRACK REQUEST ERROR:",
          error
        );
      });

  }, [location.pathname, location.search]);

  return null;
};

export default VisitorTracker;